import { render, staticRenderFns } from "./ViolationReport.vue?vue&type=template&id=4c795bab&scoped=true"
import script from "./ViolationReport.vue?vue&type=script&lang=js"
export * from "./ViolationReport.vue?vue&type=script&lang=js"
import style0 from "./ViolationReport.vue?vue&type=style&index=0&id=4c795bab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c795bab",
  null
  
)

export default component.exports